import React, { useState, useEffect } from 'react';
import { Home, Info, Layers, Award, Boxes, Mail } from 'lucide-react';
import { navTabs } from '../mock';
import { useLang } from '../i18n';

const ICONS = {
  introduction: Info,
  capabilities: Layers,
  expertise: Award,
  projects: Boxes,
  contact: Mail
};

// Native-app style bottom tab bar (mobile only).
const MobileTabBar = ({ activeTab, onTabChange }) => {
  const { t } = useLang();
  const [homeActive, setHomeActive] = useState(false);

  // Reset the Home highlight whenever a real tab becomes active externally.
  useEffect(() => { setHomeActive(false); }, [activeTab]);

  const handle = (id) => {
    setHomeActive(false);
    onTabChange(id);
    setTimeout(() => {
      const el = document.querySelector('[data-testid="tabbed-content"]');
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }, 60);
  };

  const goHome = () => {
    setHomeActive(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      data-testid="mobile-tabbar"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-[60]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div
        className="mx-3 mb-3 rounded-3xl px-2 py-2 flex items-center justify-around liquid-glass-bar"
      >
        <button
          data-testid="mtab-home"
          onClick={goHome}
          className="flex flex-col items-center justify-center gap-1 flex-1 py-1.5 rounded-2xl transition-colors"
        >
          <span
            className={`flex items-center justify-center w-10 h-8 rounded-2xl transition-all ${
              homeActive ? 'liquid-glass-pill' : ''
            }`}
          >
            <Home
              size={19}
              strokeWidth={homeActive ? 2.4 : 1.9}
              className={homeActive ? 'text-white' : 'text-white/60'}
            />
          </span>
          <span
            className={`text-[10px] font-body leading-none tracking-tight ${
              homeActive ? 'text-white font-medium' : 'text-white/55'
            }`}
          >
            {t('nav.home')}
          </span>
        </button>
        {navTabs.map((tab) => {
          const Icon = ICONS[tab.id] || Home;
          const active = !homeActive && activeTab === tab.id;
          return (
            <button
              key={tab.id}
              data-testid={`mtab-${tab.id}`}
              onClick={() => handle(tab.id)}
              className="flex flex-col items-center justify-center gap-1 flex-1 py-1.5 rounded-2xl transition-colors"
            >
              <span
                className={`flex items-center justify-center w-10 h-8 rounded-2xl transition-all ${
                  active ? 'liquid-glass-pill' : ''
                }`}
              >
                <Icon
                  size={19}
                  strokeWidth={active ? 2.4 : 1.9}
                  className={active ? 'text-white' : 'text-white/60'}
                />
              </span>
              <span
                className={`text-[10px] font-body leading-none tracking-tight ${
                  active ? 'text-white font-medium' : 'text-white/55'
                }`}
              >
                {t(`nav.${tab.id}`)}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileTabBar;
